import { useState, useEffect } from "react";

export default function CookieReader(cookieName: string): string | undefined {
  const [cookieValue, setCookieValue] = useState<string>();

  useEffect(() => {
    // Decode and split individual cookies into an array
    const decodedCookies = decodeURIComponent(document.cookie).split(";");

    // Loop through cookies to find the matching name
    for (let i = 0; i < decodedCookies.length; i++) {
      let cookie = decodedCookies[i].trim();
      // console.log("CookieReader: Checking cookie: ", cookie);
      if (cookie.indexOf(cookieName + "=") === 0) {
        setCookieValue(cookie.substring(cookieName.length + 1, cookie.length));
        break;
      }
    }
  }, []);

  return cookieValue;
}
